import styled from 'styled-components';
import colors from '../../theme/search/colors';

const Wrapper = styled.div`
  padding-top: 8px;

  .row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    @media (max-width: 767px) {
      padding: 13px;
      display: block;
      text-align: center;
      background-color: ${colors.grayNine};
      margin-bottom: 5px;
    }
  }

  input {
    background: transparent;
  }

  .input {
    width: 70%;

    @media (max-width: 767px) {
      width: calc(100% - 26px);
      padding-left: 13px;
      padding-right: 13px;
    }
  }

  .input2 {
    width: 100%;
  }

  .input3 {
    width: 100%;
  }

  .select {
    margin-top: 10px;
    margin-left: 50px;
    min-width: 150px;
    max-width: 295px;

    @media (max-width: 767px) {
      width: 100%;
      min-width: initial;
      max-width: 100%;
      margin-left: 0;
      margin-top: 15px;
    }
  }

  .select2 {
    margin-top: 10px;
    margin-right: 30px;
    max-width: 125px;
    min-width: 125px;

    @media (max-width: 767px) {
      width: 100%;
      margin-right: 0;
      margin-top: 15px;
      margin-bottom: 15px;
    }
  }

  .separator {
    color: ${colors.graySix};
    font-size: 16px;
    font-family: 'Roboto Condensed';
    font-weight: 700;
    line-height: 19px;
    border-bottom: 1px solid ${colors.graySeven};
    padding-bottom: 5px;
    margin-bottom: 17px;
    margin-top: 13px;
    text-transform: uppercase;
    transition: all 300ms;

    @media (max-width: 767px) {
      border: 0px;
      padding: 0 15px;
      margin-bottom: 8px;
      margin-top: 8px;
    }
  }

  .separator--search {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }

  .separator--search:hover {
    color: black;
    border-color: black;
  }

  .separator--search:hover > img {
    filter: opacity(100%);
  }

  .separator--search > img {
    width: 15px;
    filter: opacity(60%);
    transition: all 300ms;
  }

  .separator--search img:not(.visible) {
    transform: rotate(0);
  }

  .separator--search img.visible {
    transform: rotate(180deg);
  }

  path {
    fill: ${colors.footerLogo};
  }

  .remove-action {
    cursor: pointer;

    @media (max-width: 767px) {
      padding-top: 16px;
    }
  }

  .toggle-category--first {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 20px;
  }

  .toggle-category__footer {
    display: flex;
    gap: 20px;
  }

  .toggle-category__button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    border: 1px solid black;
    border-radius: 3px;
    cursor: pointer;
    padding: 10px 20px;
    transition: all 300ms;
  }

  .toggle-category__button:first-of-type {
    width: 102px;
    padding: 10px 0;
  }

  .toggle-category__button:not(:disabled):hover {
    background-color: #ededed;
  }

  .toggle-category__button img,
  .toggle-category__button--close img {
    width: 15px;
    filter: brightness(0);
  }

  .toggle-category__button--close {
    display: flex;
    background: none;
    border: none;
    width: auto;
    padding: 0;
    opacity: 0.5;
    cursor: pointer;
    font-size: 20px;
    transition: all 300ms;
  }

  .toggle-category__button--close:hover {
    opacity: 1;
  }

  .toggle-category--alt.visible {
    margin-bottom: 30px;
  }

  .toggle-category:not(.visible) {
    display: none;
  }

  .toggle-category__input {
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }

  .toggle-category__input:first-of-type {
    width: calc(100% - 35px);
  }

  .toggle-category__input__search {
    width: 100%;
  }

  .toggle-category__input__select {
    padding: 10px 50px 10px 10px;
    background-color: white;
    -webkit-appearance: none;
    appearance: none;
    -moz-appearance: none;
    background-image: url('https://www.svgrepo.com/show/80156/down-arrow.svg');
    background-repeat: no-repeat;
    background-size: 12px 12px;
    background-position: calc(100% - 16px);
    cursor: pointer;
  }

  .checkbox-zone {
    display: flex;
    width: 100%;
    justify-content: space-between;
    font-size: 15px;
    overflow: hidden;

    @media (min-width: 768px) {
      > div {
        width: 33%;
      }

      > div:nth-child(2) {
        padding-left: 35px;
      }
    }

    @media (max-width: 767px) {
      display: block;
      width: calc(100% - 22px);
      margin-left: 11px;
      margin-right: 11px;

      > div {
        padding-bottom: 10px;
      }

      > div:nth-child(3) {
        padding-bottom: 30px;
      }
    }

    & .title {
      text-transform: uppercase;
      font-weight: bold;
      font-family: 'Roboto Condensed';
      font-weight: 700,
      color: ${colors.blackThree};
      text-align: left;
      margin-bottom: 20px;

      @media (max-width: 767px) {
        margin-top: 20px;
        margin-bottom: 16px;
      }
    }
  }

  .checkbox-zone:not(.visible) {
    margin-bottom: 10px;
  }

  .button-search-zone {
    display: flex;
    justify-content: center;
  }

  .button-container-search {
    padding-bottom: 30px;
    display: flex;
    justify-content: space-between;
    width: calc(100% - 50px);
    max-width: 1000px;

    @media (max-width: 767px) {
      width: calc(100% - 22px);
      display: block;
      margin-left: 11px;
      margin-right: 11px;

      > div:nth-child(2) {
        padding-top: 17px;
      }
    }
  }

  .hr {
    @media (max-width: 767px) {
      margin-top: 11px;
      margin-bottom: 11px;
    }
  }

  .advanced {
    &__header {
      display: flex;
      align-items: center;
      gap: 24px;
      margin: 20px 0 30px 0;

      &--buttons {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      &__buttons {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
      }

      &:first-of-type {
        margin: 0;
      }

      &__button {
        border: 1px solid #cf4825FF;
        color: #cf4825FF;
        background-color: white;
        padding: 8px 13px;
        border-radius: 5px;
        cursor: pointer;
        transition: all 300ms;

        &--help {
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid #cf4825FF;
          border-radius: 100px;
          padding: 10px;
          width: 28px;
          height: 28px;

          &:hover {
            background-color: #e7e7e7ff !important;
          }
        }

        &__img {
          height: 16px;
          width: 16px;
        }

        &:hover {
          background-color: #cf4825FF;
          color: white;
        }

        &--search {
          background-color: #cf4825FF;
          color: white;

          &:hover {
            background-color: #932f17ff;
            border-color: #932f17ff;
            color: white;
          }
        }
      }
    }

    &__fields {
      margin-top: 30px;

      &__text {
        font-weight: normal;
        margin: 0 0 10px 0;

        &--specific {
          margin: 20px 0 0 0;
        }
      }

      &__items {
        display: flex;
        flex-direction: column;
        gap: 7px;

        &__field {
          display: flex;
          gap: 7px;

          &__right__options,
          &__input,
          &__conditions {
            padding: 8px 12px;
            border-radius: 5px;
            border: 1px solid #dbdbdbff;
            background-color: white;
          }

          &__right__options,
          &__conditions {
            background-image: url('data:image/svg+xml;utf8,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor"/></svg>');
            background-repeat: no-repeat;
            background-position: right 10px center;
            background-size: 20px;
            appearance: none;
            -webkit-appearance: none;
            -moz-appearance: none;
            cursor: pointer;
            padding-right: 40px;
          }

          &__input {
            flex: 1;
          }

          &__right {
            display: flex;
            gap: 7px;
            width: 257px;

            &__options {
              flex: 1;
            }

            &__remove {
              background: white;
              padding: 8px;
              border: 1px solid #dbdbdbff;
              border-radius: 5px;
              cursor: pointer;
              transition: all 300ms;

              &:hover {
                background-color: #f0f0f0;
              }

              &__img {
                width: 20px;
              }
            }
          }
        }
      }

      &__buttons {
        display: flex;
        gap: 7px;
        margin-top: 7px;

        &__add,
        &__remove {
          background: white;
          border: 1px solid #dbdbdbff;
          border-radius: 5px;
          padding: 8px 12px;
          cursor: pointer;
          transition: all 300ms;

          &:hover {
            background-color: #f0f0f0;
          }
        }

        &__add {
          width: 94px;
          padding: 8px;
        }
      }
    }

    &__block {
      display: flex;
      flex-direction: column;
      flex: 1;
      padding-top: 20px;
      border-top: 1px solid #dbdbdbff;

      &--extended,
      &s {
        margin-top: 20px;
      }

      &s {
        display: flex;
        justify-content: space-between;
        gap: 50px;
      }

      &__header {
        display: flex;
        align-items: center;
        gap: 20px;
        margin: 0 0 10px 0;

        .advanced__block__title {
          margin: 0;
        }

        &__radios {
          display: flex;
          align-items: center;
          gap: 5px;
          border: none;
          padding: 0;

          &__item {
            &__input:checked + .advanced__block__header__radios__item__label {
              text-decoration: underline;
            }

            &__label {
              cursor: pointer;
            }
          }
        }
      }

      &__radios {
        display: flex;
        align-items: center;
        gap: 20px;
        border: none;
        padding: 0;

        &__item {
          display: flex;
          align-items: center;
          gap: 5px;

          &__input {
            -webkit-appearance: radio;
          }

          &__input,
          &__label {
            cursor: pointer;
          }
        }
      }

      &__date {
        display: flex;
        gap: 10px;
        align-items: center;

        &__input {
          padding: 8px 12px;
          border-radius: 5px;
          border: 1px solid #dbdbdbff;
        }
      }
    }

    &__items {
      display: flex;
      flex-direction: column;
      gap: 12px;

      &__item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        gap: 12px;

        &__left {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        &__input {
          -webkit-appearance: radio;
          cursor: pointer;
        }

        &__label {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex: 1;
          cursor: pointer;
        }

        &__count {
          margin: 0;
        }
      }

      &__empty {
        margin: 0;
      }
    }

    &__loading {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.8);
      color: white;
      z-index: 9999;
      height: 100%;
      width: 100%;

      &__img {
        width: 50px;
        animation: spin 2s linear infinite;
      }

      @keyframes spin {
        from {transform:rotate(0deg);}
        to {transform:rotate(360deg);}
      }
    }
  }

  .button--help {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 100px;

    &__tooltip {
      position: absolute;
      top: -45px;
      color: #252525;
      background: white;
      padding: 10px 12px;
      border-radius: 5px;
      white-space: nowrap;
      visibility: hidden;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      border: 1px solid #bfbfbf;
    }

    &:hover .button--help__tooltip {
      visibility: initial;
    }
  }
`;

const svgStyle = {
  width: 20,
  margin: 10,
  marginTop: 15
};

export { Wrapper, svgStyle };



// WEBPACK FOOTER //
// ./src/pages/AdvancedSearch/style.js